export enum Flags {
  ShowOpeningHours = 'showopeninghours',
  showDidThisHelp = 'showdidthishelp',
  alignConfirmationLeft = 'alignconfirmationleft',
  saveCardSelection = 'savecardselection',
  customerEffortScore = 'customereffortscore',
}
